const VALID_UNITS = ["mcg/kg", "mg/kg", "g/kg"];

const VALID_CONCENTRATIONS_UNITS = ["mg", "g", "mcg"];

const VALID_VOLUME_UNITS = ["mL", "L"];

export { VALID_UNITS, VALID_CONCENTRATIONS_UNITS, VALID_VOLUME_UNITS };
